import { styled } from '@mui/system'

export const CardTitle = styled('div')`
    margin-bottom: 24px;
`

export const ResetMfaWrapper = styled('div')`
    margin-top: 24px;
`
